import React, { FC } from 'react'

import { AcceptTermsProps } from './AcceptTerms'
import * as SC from './styled'
import { FullFormProps } from './FullForm'
import { CompletedProps } from './Completed'

export type DeclarationFormProps = {
  className?: string
  step: number
  background: string
  acceptTerms: AcceptTermsProps
  form: FullFormProps
  complete: CompletedProps
}

const DeclarationForm: FC<DeclarationFormProps> = (props) => {
  const { className, background, step, acceptTerms, form, complete } = props
  return (
    <SC.Container className={className} $background={background}>
      {step === 0 && <SC.AcceptTerms {...acceptTerms} />}
      {step > 0 && <SC.FullForm {...form} />}
      {step === -1 && <SC.Completed {...complete} />}
    </SC.Container>
  )
}

export default DeclarationForm
